export enum EMAIL_STATUS {
  SAVED,
  READY,
  SENT,
}
